import * as configuratorSelectors from '@store/configurator/selectors';
import { ConfiguratorState } from './types';

export const getConfiguratorSelectors = (state: ConfiguratorState) => {
  return Object.keys(configuratorSelectors).reduce(function(result, key) {
    result[key] = () => configuratorSelectors[key](state);
    return result;
  }, {}) as typeof configuratorSelectors;
};
